import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Search from "./pages/Search";
import NotFound from "./pages/NotFound";
import TradeName from "./pages/TradeName";
import Ingredient from "./pages/Ingredient";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from './components/ErrorBoundary';
import Manufacturer from "./pages/Manufacturer";
import IngredientItem from "./pages/IngredientItem";
import ManufacturerItem from "./pages/ManufacturerItem";
import TradeNameItem from "./pages/TradeNameItem";
import Compare from "./pages/Compare";
import IngredientSearch from "./pages/IngredientSearch";
import Terms from "./pages/Terms";
import Policy from "./pages/Policy";
import About from "./pages/About";
import Disclaimer from "./pages/Disclaimer";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BlogCategory from "./pages/BlogCategory";
import usePageTracking from "./utils/usePageTracking";
import { CompareProvider } from "./hooks/useCompare";
import CompareFloatingBar from "./components/CompareFloatingBar";
import { IngredientSessionProvider } from "./hooks/useIngredientSession";
import IngredientSessionBar from "./components/IngredientSessionBar";

// Component to handle page tracking inside Router context
function PageTracker() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <CompareProvider>
        <IngredientSessionProvider>
          <Router>
            <PageTracker />
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<Search />} />
              <Route path="/tradenames" element={<TradeName />} />
              <Route path="/tradenames/:uri" element={<TradeNameItem />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/ingredients" element={<Ingredient />} />
              <Route path="/ingredients/search" element={<IngredientSearch />} />
              <Route path="/ingredients/:uri" element={<IngredientItem />} />
              <Route path="/manufacturers" element={<Manufacturer />} />
              <Route path="/manufacturers/:uri" element={<ManufacturerItem />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/policy" element={<Policy />} />
              <Route path="/about" element={<About />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/category/:categorySlug" element={<BlogCategory />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <CompareFloatingBar />
            <IngredientSessionBar />
          </Router>
        </IngredientSessionProvider>
      </CompareProvider>
    </ErrorBoundary>
  );
}

export default App;

